<enauka-simple-header></enauka-simple-header>
<section class="container regulamin">
  <div class="row">
      <div class="col-lg-12">
          <article class="pl-3 pl-sm-0">
              <h1>Regulamin</h1>
              <ol class="rules-list">
                  <li>Organizatorem projektu jest Wydział Matematyki i Nauk Informacyjnych Politechniki Warszawskiej.</li>
                  <li>Projekt przeznaczony jest dla uczniów klas czwartych szkół podstawowych i ich nauczycieli matematyki.</li>
                  <li>W projekcie mogą uczestniczyć tylko uczniowie szkół, które podpiszą umowę z Politechniką Warszawską.</li>
                  <li>Projekt jest przeznaczony dla szkół uczących w języku polskim. Mogą w nim uczestniczyć szkoły z dowolnego miejsca - zarówno
                      w kraju jak i za granicą.</li>
                  <li>Do projektu mogą przystępować szkoły podstawowe publiczne, prywatne i społeczne, posiadające conajmniej jeden oddział
                      klas czwartych.</li>
                  <li>Liczba miejsc jest ograniczona. O dołączeniu decyduje kolejność napływania zgłoszeń. Preferowane są szkoły z terenów wiejskich.</li>
                  <li>Zgłoszenia chęci współpracy można dokonywać elektronicznie poprzez formularz kontaktowy
                      na stronie <a href="https://power.mini.pw.edu.pl" target="_blank">https://power.mini.pw.edu.pl</a> albo wysyłając list na adres
                      <p class="address-rules-list">POWER - klasa 4<br>
                          Wydział Matematyki i Nauk Informacyjnych<br>
                          Politechnika Warszawska<br>
                          ul. Koszykowa 75<br>
                          00-662 Warszawa
                      </p></li>
                  <li>Projekt podzielony jest na dwie części - indywidualną naukę matematyki w autorskim systemie e-learningowym, koordynowaną
                      przez organizatora projektu oraz zajęcia warsztatowe, które będą odbywały się w Warszawie w gmachu Wydziału Matematyki
                      i Nauk Informacyjnych Politechniki Warszawskiej.</li>
                  <li>Nauka matematyki jest dostępna online dla wszystkich uczestników projektu. Zadania podzielone są na moduły,
                      które są systematycznie udostępniane uczniom. Zadania przeznaczone są do indywidualnego rozwiązywania
                      przez uczniów - na komputerach z dostępem do internetu.</li>
                  <li>Do udziału w części warsztatowej zostaną zaproszeni wybrani uczestnicy, którzy udzielą odpowiedzi na wszystkie
                      przygotowane dla nich zadania matematyczne oraz wykażą się największym zaangażowaniem.</li>
                  <li>Dla uczniów poniżej szesnastego roku życia, na uczestnictwo w programie wymagana jest pisemna zgoda opiekuna prawnego.</li>
              </ol>
          </article>
      </div>
  </div>
</section>
